import AgeGate from "@/components/Templates/Main/AgeGate";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { pageHandler } from "@/lib/pages-handler";
import { _getSiteConfiguration } from "@/dato-api/site-config-cache";

export default function AgeGatePage({ siteConfig, redirectTo }) {
	return <AgeGate siteConfig={siteConfig} redirectTo={redirectTo} />;
}

export async function getServerSideProps(context) {
	const siteConfig = await _getSiteConfiguration(context.locale, false).then(
		(result) => result.siteConfiguration
	);
	const result = [];
	const pageData = await pageHandler(
		context,
		serverSideTranslations,
		result,
		""
	);

	const redirectTo = context.query.redirect || null;

	return {
		props: {
			siteConfig: siteConfig,
			redirectTo: redirectTo,
			...pageData.sst,
			data: { ...pageData.data },
			preview: pageData.preview,
		},
	};
}
